import React, { useRef, useEffect } from 'react';

import './ModalContentWrapper.scss';

const ModalContentWrapper = ({width, onScrollBottomReached, children, className, columns}) =>
{
    const refContainer = useRef(null);

    useEffect(() => {
        refContainer.current.scrollTop = 0;
    }, []);

    const isScrollBottomHandlerRequired = () =>
    {
        return onScrollBottomReached !== undefined ;
    }

    const handleScroll = (e) =>
    {
        const diff = parseInt((e.target.scrollHeight - e.target.scrollTop),10) ;

        const n1 = +diff ;
        const n2 = +(e.target.clientHeight) ;

        if ( Math.abs(n1-n2) < 10 )
        {
            if ( onScrollBottomReached !== undefined )
            {
                onScrollBottomReached();
            }
        }
    }

    const handler = isScrollBottomHandlerRequired() ? handleScroll : null ;

    const style = width !== undefined ? { width: width } : {} ;

    const colClassName = ( columns === undefined || columns === 1 ) ? '' : ' two' ;

    const innerClassName = className === undefined ? "modal-content" + colClassName : "modal-content" + colClassName + ' ' + className ;

    return (
        <div ref={refContainer} className={innerClassName} style={style} onScroll={handler}>
            { children }
        </div>

    )
}

export default ModalContentWrapper ;